import React from 'react';

import { lbLogo } from "../img/otherImgs.js";
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import NavLinks from './NavLinks.js';

function NavBar() {
    return (
        <div className="NavBar">
            <div className="NavLeft">
                <NavLink exact={true} to="/">
                    <img 
                        src={lbLogo}
                        alt="Laura Brown logo, initials L.B."
                        width="auto"
                        height="56px"
                        />
                </NavLink>
                <div className="NavName">
                    <h1>Laura Brown</h1>
                    <h2>Web Developer</h2>
                </div>
            </div>
            <div className="NavRight">
                <NavLinks />
            </div>
        </div>
    );
}

export default NavBar;